import { useRef } from "react";
// Alert on page change (except first load)

import React, { useEffect, useState } from "react";
import {
  Layout,
  Menu,
  Card,
  ConfigProvider,
  Avatar,
  Drawer,
  Dropdown,
  Tooltip,
  Breadcrumb,
  message,
  Select,
  Space,
  Badge,
  Button,
} from "antd";
import {
  DownOutlined,
  MenuOutlined,
  CheckOutlined,
  CloseOutlined,
  UserOutlined,
  MessageOutlined,
  WhatsAppOutlined,
  MailOutlined,
  ApiOutlined,
  CalendarOutlined,
  LogoutOutlined,
  RightOutlined,
  UserSwitchOutlined,
  DashboardOutlined,
  TeamOutlined,
  CustomerServiceOutlined,
  BankOutlined,
  BellOutlined,
} from "@ant-design/icons";
import { useLocation, Link, useNavigate } from "react-router-dom";
import { ReactComponent as Dashboard } from "../assets/Icons/dashboardNew.svg";
import { ReactComponent as TargetAchievement } from "../assets/Icons/targetAchievement.svg";
import { ReactComponent as Reports } from "../assets/Icons/reports.svg";
import { ReactComponent as Portfolio } from "../assets/Icons/portfolioIcon.svg";
import { ReactComponent as Permission } from "../assets/Icons/permissionIcon.svg";
import { ReactComponent as Traceability } from "../assets/Icons/tracebilityIcon.svg";
import { ReactComponent as AgencyDetail } from "../assets/Icons/agencyDetail.svg";
import { ReactComponent as Allocate } from "../assets/Icons/allocationIcon.svg";
import { ReactComponent as Upload } from "../assets/Icons/uploadIcon.svg";
import { ReactComponent as Analysis } from "../assets/Icons/analysisIcon.svg";
import { ReactComponent as SeparatorIcon } from "../assets/Icons/separatorIcon.svg";
import { ReactComponent as SummaryReportIcon } from "../assets/Icons/summary-report-svg.svg";
import NotificationDrawer from "../components/NotificationDrawer/NotificationDrawer";
import { addRealtimeNotification, fetchNotifications, selectUnreadCount } from "../store/notificationsSlice";
import logo from "../assets/Icons/sidebarlogo.svg";
import fullLogo from "../assets/Images/fulllogo_.png";
import { ReactComponent as CashIcon } from "../assets/Icons/cashicon.svg";
import "./PageLayout.scss";
import { useDispatch, useSelector } from "react-redux";
import { logout, logoutUser, setBreakStatus, unregisterDeviceToken, setSelectedRole, updateCurrentRole } from "../store/auth";
import { requestForToken, messaging } from "../firebase";
import useFcmRegistration, { clearFcmRegistration } from "../hooks/useFcmRegistration";
import { onMessage } from "firebase/messaging";
import toast, { Toaster } from "react-hot-toast";
import Tabs from "../Reuseable/Tabs/Tabs";
import { setPriceFormat } from "../store/priceFormat";
import { clearQuery } from "../store/filters";
import { getUserType, formatCurrencyNoTooltip } from "../assets/helpers";
import axios from "axios";
const { Header, Content, Sider } = Layout;
/* One figure rendered in every format, so the menu shows what each choice
   does to an amount instead of asking the user to know the units. */
const FORMAT_SAMPLE_AMOUNT = 12500000;
const ROLE_LABELS = {
  telecaller: "Telecaller",
  supervisor: "Supervisor",
  agency: "Agency",
  team_lead: "Team Lead",
  field_agent: "Field Agent",
  superuser: "Administrator",
};

const PageLayout = ({ children, title: propTitle, showFilter = true }) => {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 900);
  const [notificationDrawerVisible, setNotificationDrawerVisible] = useState(false);

  // Professional Notification Sound Generator (No assets needed)
  const playNotificationSound = () => {
    try {
      const AudioContext = window.AudioContext || window.webkitAudioContext;
      if (!AudioContext) return;
      const ctx = new AudioContext();

      const playOscillator = (freq, startTime, duration) => {
        const osc = ctx.createOscillator();
        const gain = ctx.createGain();
        osc.type = 'sine';
        osc.frequency.setValueAtTime(freq, startTime);
        gain.gain.setValueAtTime(0, startTime);
        gain.gain.linearRampToValueAtTime(0.2, startTime + 0.05);
        gain.gain.exponentialRampToValueAtTime(0.01, startTime + duration);
        osc.connect(gain);
        gain.connect(ctx.destination);
        osc.start(startTime);
        osc.stop(startTime + duration);
      };

      const now = ctx.currentTime;
      playOscillator(880, now, 0.4);      // High pitch
      playOscillator(1046.50, now + 0.15, 0.6); // Higher pitch (Ding-Ding effect)
    } catch (e) {
      console.warn("Audio blocked or unsupported", e);
    }
  };
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [collapsed, setCollapsed] = useState(true);
  const [openKeys, setOpenKeys] = useState([]); // State for submenu open keys
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { token, user, inOnTeaBreak, isOnLunchBreak } = useSelector((state) => state.auth);
  const unreadCount = useSelector(selectUnreadCount);
  const { format } = useSelector((state) => state.priceFormat);
  const [viewportWidth, setViewportWidth] = useState(window.innerWidth);
  const [userMenuOpen, setUserMenuOpen] = useState(false);
  const [formatMenuOpen, setFormatMenuOpen] = useState(false);
  const { pathname } = useLocation();
  const [activeBreak, setActiveBreak] = useState(() => sessionStorage.getItem("activeBreak") || null);

  // The bell badge reads the same slice the drawer does, so the list has to be
  // loaded up front - otherwise the count sits at 0 until the drawer is opened.
  useEffect(() => {
    if (token && user?.selectedRole === "telecaller") {
      dispatch(fetchNotifications());
    }
  }, [dispatch, token, user?.selectedRole]);

  useEffect(() => {
    // 1. Setup REAL listener for backend payloads
    if (messaging) {
      const unsubscribe = onMessage(messaging, (payload) => {
        playNotificationSound();

        // Dispatch to store so drawer gets it
        dispatch(addRealtimeNotification({
          id: Date.now(), // Generate a temp ID
          title: payload?.notification?.title,
          body: payload?.notification?.body,
          data: payload?.data,
          created_at: new Date().toISOString(),
          is_read: false
        }));

        // Custom Styled Notification
        toast.custom((t) => (
          <div
            style={{
              opacity: t.visible ? 1 : 0,
              transform: t.visible ? 'translateY(0)' : 'translateY(-20px)',
              transition: 'all 0.3s cubic-bezier(0.68, -0.55, 0.265, 1.55)',
              background: '#fff',
              borderLeft: '4px solid #F15A29', // Brand Orange
              boxShadow: '0 10px 25px -5px rgba(0, 0, 0, 0.1), 0 8px 10px -6px rgba(0, 0, 0, 0.1)',
              borderRadius: '10px',
              padding: '16px',
              display: 'flex',
              alignItems: 'flex-start',
              gap: '14px',
              maxWidth: '380px',
              width: '100%',
              pointerEvents: 'auto'
            }}
          >
            <div style={{ background: '#FFF3ED', padding: '8px', borderRadius: '50%', display: 'flex' }}>
              <img src={logo} alt="logo" style={{ width: '22px', height: '22px' }} />
            </div>
            <div style={{ flex: 1, marginTop: '2px' }}>
              <h4 style={{ margin: 0, color: '#111827', fontSize: '15px', fontWeight: '600' }}>
                {payload?.notification?.title}
              </h4>
              <p style={{ margin: '6px 0 0', color: '#4B5563', fontSize: '14px', lineHeight: '1.4', whiteSpace: 'pre-wrap' }}>
                {payload?.notification?.body}
              </p>
            </div>
            <button
              onClick={() => toast.dismiss(t.id)}
              style={{ background: 'none', border: 'none', cursor: 'pointer', color: '#9CA3AF', padding: '4px', display: 'flex' }}
            >
              <CloseOutlined style={{ fontSize: '14px' }} />
            </button>
          </div>
        ), { duration: 6000, position: 'top-right' });
      });
      return () => unsubscribe();
    }
  }, []);

  // Owns FCM device-token registration for telecallers (login + role switch).
  useFcmRegistration();

  useEffect(() => {
    if (inOnTeaBreak) {
      setActiveBreak("tea");
      sessionStorage.setItem("activeBreak", "tea");
    } else if (isOnLunchBreak) {
      setActiveBreak("lunch");
      sessionStorage.setItem("activeBreak", "lunch");
    } else {
      setActiveBreak(null);
      sessionStorage.removeItem("activeBreak");
    }
  }, [inOnTeaBreak, isOnLunchBreak]);


  const handleBreakToggle = async (type) => {
    const isEnding = activeBreak === type;
    const previousBreak = activeBreak;
    const nextBreak = isEnding ? null : type;
    setActiveBreak(nextBreak);
    if (nextBreak) {
      sessionStorage.setItem("activeBreak", nextBreak);
    } else {
      sessionStorage.removeItem("activeBreak");
    }

    try {
      if (previousBreak && previousBreak !== type) {
        await axios.post(
          "auth/attendance/action/",
          {
            break_type: previousBreak,
            action: "end_break",
          },
          {
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
          }
        );
      }

      const res = await axios.post(
        "auth/attendance/action/",
        {
          break_type: type,
          action: isEnding ? "end_break" : "start_break",
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );
      if (res.status == 200) {
        toast.success(`${res?.data?.message}`);
        if (isEnding) {
          dispatch(setBreakStatus({ break_type: type, is_on_break: false }));
        } else {
          if (previousBreak && previousBreak !== type) {
            dispatch(setBreakStatus({ break_type: previousBreak, is_on_break: false }));
          }
          dispatch(setBreakStatus({ break_type: type, is_on_break: true }));
        }
      }

    } catch (error) {
      console.warn("Telecaller break API not found or failed:", error);
    }

    window.postMessage(
      {
        type: "AGENT_BREAK_TOGGLE",
        breakType: type,
        action: isEnding ? "resume" : "pause",
      },
      "*"
    );
  };

  useEffect(() => {
    const checkScreenSize = () => {
      setIsMobile(window.innerWidth <= 900);
    };

    checkScreenSize(); // Initial check
    window.addEventListener("resize", checkScreenSize);

    return () => {
      window.removeEventListener("resize", checkScreenSize);
    };
  }, []);

  const firstLoadRef = useRef(true);
  useEffect(() => {
    if (firstLoadRef.current) {
      firstLoadRef.current = false;
      return;
    }
    // dispatch(clearQuery());
  }, [location.pathname]);

  const extraRoutes = () => {
    switch (getUserType(user)) {
      case "telecaller":
        return [
          {
            key: "/field-agent-allocation",
            icon: <Portfolio />,
            label: (
              <Link to="/field-agent-allocation">Field Agent Allocations</Link>
            ),
          },
          {
            key: "/telecaller-summary-report",
            icon: (
              <SummaryReportIcon style={{ width: "20px", height: "20px" }} />
            ),
            label: <Link to="/telecaller-summary-report">Summary Report</Link>,
          },
        ];
      default:
        return [];
    }
  };

  let menuItems = [
    {
      key: "/dashboard",
      icon: <Dashboard />,
      label: "Dashboard",

      children: [
        {
          key: "/dashboard",
          icon: "",
          label: <Link to="/dashboard">Dashboard</Link>,
        },
        getUserType(user) === "agency" && {
          key: "/bank-dashboard",
          icon: "",
          label: <Link to="/bank-dashboard">Bank Dashboard</Link>,
        },
      ].filter(Boolean),
    },
    (getUserType(user) === "agency" || getUserType(user) === "supervisor") && {
      key: "/agency/user",
      icon: <AgencyDetail />,
      label: "AgencyDetail",
      children: [
        {
          key: "/agency/user",
          icon: "",
          label: <Link to="/agency/user">User</Link>,
        },
        getUserType(user) === "agency" && {
          key: "/agency/product",
          icon: "",
          label: <Link to="/agency/product">Product</Link>,
        },
        getUserType(user) === "agency" && {
          key: "/agency/area-codes",
          icon: "",
          label: <Link to="/agency/area-codes">Area Codes</Link>,
        },
        getUserType(user) === "agency" && {
          key: "/permission",
          icon: "",
          label: <Link to="/permission">Permissions</Link>,
        },
      ].filter(Boolean),
    },
    getUserType(user) === "agency" && {
      key: "portfolio-group",
      icon: <Portfolio />,
      label: "Company",
      children: [
        // {
        //   key: "/company",
        //   icon: "",
        //   label: <Link to="/company">Company</Link>,
        // },
        {
          key: "/portfolio",
          icon: "",
          label: <Link to="/portfolio">Portfolio</Link>,
        },
      ],
    },
    getUserType(user) === "agency" && {
      key: "/rules",
      icon: <Permission />,
      label: <Link to="/rules">Rules</Link>,
    },
    (getUserType(user) === "agency" || getUserType(user) === "supervisor") && {
      key: "/allocation",
      icon: <Allocate />,
      label: "Allocation",
      children: [
        getUserType(user) === "agency" && {
          key: "/allocation/user-wise",
          icon: "",
          label: <Link to="/allocation/user-wise">Allocation user wise</Link>,
        },
        {
          key: "/allocation/cases",
          icon: "",
          label: <Link to="/allocation/cases">Cases</Link>,
        },
        getUserType(user) === "agency" && {
          key: "/allocation/feedback-cases",
          icon: "",
          label: <Link to="/allocation/feedback-cases">Feedback Cases</Link>,
        },
      ].filter(Boolean),
    },
    getUserType(user) === "telecaller" && {
      key: "/allocation/cases",
      icon: <Permission />,
      label: "Cases",
      children: [
        {
          key: "/allocation/cases",
          icon: "",
          label: <Link to="/allocation/cases">Cases</Link>,
        },
        {
          key: "/cases-feedback",
          icon: "",
          label: <Link to="/cases-feedback">Cases Feedback</Link>,
        },
      ],
    },
    ...extraRoutes(),
    (getUserType(user) === "agency" || getUserType(user) === "supervisor") && {
      key: "/geo-tagging",
      icon: <Traceability />,
      label: <Link to="/geo-tagging">GEO Tagging</Link>,
    },
    getUserType(user) === "agency" && {
      key: "/target-achievement",
      icon: <TargetAchievement />,
      label: <Link to="/target-achievement">Target & Achievement</Link>,
    },
    getUserType(user) === "agency" && {
      key: "/reports",
      icon: <Reports />,
      label: <Link to="/reports">Reports</Link>,
    },

    // {
    //   key: "/upload",
    //   icon: <Upload />,
    //   label: <Link to="/upload">Upload</Link>,
    // },
    getUserType(user) === "agency" && {
      key: "/analysis/overview",
      icon: <Analysis />,
      label: "Analysis",
      children: [
        {
          key: "/analysis/overview",
          icon: "",
          label: <Link to="/analysis/overview">Overview</Link>,
        },
        {
          key: "/analysis/coverage",
          icon: "",
          label: <Link to="/analysis/coverage">Coverage</Link>,
        },
        {
          key: "/analysis/productivity",
          icon: "",
          label: <Link to="/analysis/productivity">Productivity</Link>,
        },
        {
          key: "/analysis/performance",
          icon: "",
          label: <Link to="/analysis/performance">Performance</Link>,
        },
      ],
    },

    getUserType(user) === "agency" && {
      key: "/communication",
      icon: <ApiOutlined />,
      label: "Communication",
      children: [
        // {
        //   key: "/communication/sms",
        //   icon: <MessageOutlined />,
        //   label: <Link to="/communication/sms">SMS</Link>,
        // },
        {
          key: "/communication/sms",
          icon: <MessageOutlined />,
          label: "SMS",
          children: [
            {
              key: "/communication/sms/create-template",
              icon: "",
              label: <Link to="/communication/sms/create-template">Create Template</Link>,
            },
            {
              key: "/communication/sms/template",
              icon: "",
              label: <Link to="/communication/sms/template">Template</Link>,
            },
          ],
        },
        {
          key: "/communication/whatsapp",
          icon: <WhatsAppOutlined />,
          label: "Whatsapp",
          children: [
            {
              key: "/communication/whatsapp/create-template",
              icon: "",
              label: <Link to="/communication/whatsapp/create-template">Create Template</Link>,
            },
            {
              key: "/communication/whatsapp/template",
              icon: "",
              label: <Link to="/communication/whatsapp/template">Template</Link>,
            },
          ],
        },
        {
          key: "/communication/email",
          icon: <MailOutlined />,
          label: "Email",
          children: [
            {
              key: "/communication/email/create-template",
              icon: "",
              label: <Link to="/communication/email/create-template">Create Template</Link>,
            },
            {
              key: "/communication/email/template",
              icon: "",
              label: <Link to="/communication/email/template">Template</Link>,
            },
          ],
        },
      ],
    },
    getUserType(user) === "telecaller" && {
      key: "telecaller/ptp-list",
      icon: <Permission />,
      label: "Cases",
      children: [
        {
          key: "/telecaller/ptp-list",
          icon: "",
          label: <Link to="/telecaller/ptp-list">PTP List</Link>,
        },
        {
          key: "/telecaller/callback-list",
          icon: "",
          label: <Link to="/telecaller/callback-list">Callback List</Link>,
        },
      ],
    },
    getUserType(user) === "telecaller" && {
      key: "/campaign",
      icon: <Analysis />,
      label: <Link to="/campaign">Campaign </Link>,
    },
    ["telecaller", "agency", "supervisor"].includes(getUserType(user)) && {
      key: "/attendance",
      icon: <CalendarOutlined />,
      label: <Link to="/attendance">Attendance</Link>,
    },
    getUserType(user) === "agency" && {
      key: "/campaigns",
      icon: <Analysis />,
      label: "Campaigns",
      children: [
        {
          key: "/campaign",
          icon: "",
          label: <Link to="/campaign">Campaign</Link>,
        },
        {
          key: "/whatsapp-campaign",
          icon: "",
          label: <Link to="/whatsapp-campaign">Whatsapp Campaign</Link>,
        },
        {
          key: "/sms-campaign",
          icon: "",
          label: <Link to="/sms-campaign">SMS Campaign</Link>,
        },
      ],
    },
    getUserType(user) === "agency" && {
      key: "/script",
      icon: <Analysis />,
      label: <Link to="/script">Call Script </Link>,
    },
  ];

  if (getUserType(user) === "superuser") {
    menuItems = [
      {
        key: "/agencies",
        icon: <AgencyDetail />,
        label: <Link to="/agencies">Agencies</Link>,
      }
    ];
  }

  /* A group with exactly one leaf under it offers no choice: collapsed, the
     rail opened a hover flyout holding a single option, and expanded it cost a
     click to reveal one row. Such a group is rendered as that leaf directly -
     the group keeps its icon, and takes the child's label and route.

     Groups shrink to one child dynamically too: several lists here are built
     with `role === "agency" && {...}` entries and then filtered, so which
     groups qualify depends on who is signed in. */
  const flattenSingleChildGroups = (items = []) =>
    items.filter(Boolean).map((item) => {
      const children = (item?.children || []).filter(Boolean);
      if (children.length === 0) return item;

      const [only] = children;
      const onlyIsLeaf =
        children.length === 1 && !(only?.children || []).filter(Boolean).length;

      if (!onlyIsLeaf) {
        return { ...item, children: flattenSingleChildGroups(children) };
      }

      const { children: _collapsed, ...rest } = item;
      return { ...rest, key: only.key, label: only.label };
    });

  menuItems = flattenSingleChildGroups(menuItems);

  // Determine the selected key and default open keys based on the current location
  const getSelectedAndOpenKeys = () => {
    const path = location.pathname;
    const isSuperuser = getUserType(user) === "superuser";
    let selectedKey = isSuperuser ? "/agencies" : "/";
    let openKeysArray = [];

    // If path is root or empty, set default selected key
    if (path === "/" || path === "") {
      return { selectedKey: isSuperuser ? "/agencies" : "/dashboard", openKey: [] };
    }

    const findKeys = (items, parentKeys = []) => {
      for (const item of items) {
        if (!item) continue;
        if (item.key === path) {
          selectedKey = item.key;
          openKeysArray = parentKeys;
          return true;
        }
        if (item.children) {
          const childMatched = findKeys(item.children, [...parentKeys, item.key]);
          if (childMatched) return true;
          if (path.startsWith(item.key + "/")) {
            selectedKey = item.key;
            openKeysArray = parentKeys;
            return true;
          }
        } else if (path.startsWith(item.key + "/")) {
          selectedKey = item.key;
          openKeysArray = parentKeys;
          return true;
        }
      }
      return false;
    };

    findKeys(menuItems);
    return { selectedKey, openKey: openKeysArray };
  };

  const { selectedKey, openKey } = getSelectedAndOpenKeys();

  // useEffect(() => {
  //   // Initialize openKeys based on the current route
  //   setOpenKeys(openKey);
  // }, [location.pathname]);

  // Handle submenu open/close without interfering with navigation
  const handleOpenChange = (keys) => {
    setOpenKeys(keys);
  };

  // Handle click on submenu title to open/close without navigating
  const handleSubMenuClick = (key) => {
    setDrawerOpen(false);
    const isOpen = openKeys.includes(key);
    if (isOpen) {
      setOpenKeys(openKeys.filter((k) => k !== key)); // Close submenu
    } else {
      setOpenKeys([...openKeys, key]); // Open submenu
    }
  };

  const titleMap = {
    "/": "Upload",
    "/analysis/overview": "Analysis",
    "/analysis/coverage": "Coverage",
    "/analysis/performance": "Performance",
  };
  const formatPriceKeys = [
    { label: "Absolute", short: "Abs", value: "Absolute" },
    { label: "Crore", short: "Cr", value: "Crore" },
    { label: "Lakh", short: "Lakh", value: "Lakh" },
  ];
  const activeFormat =
    formatPriceKeys.find((item) => item.value === format) || formatPriceKeys[0];

  const formatMenu = (
    <div className="app-formatmenu" role="listbox" aria-label="Amount format">
      <div className="app-formatmenu__head">Show amounts in</div>
      {formatPriceKeys.map((item) => {
        const isActive = item.value === activeFormat.value;
        return (
          <button
            type="button"
            role="option"
            aria-selected={isActive}
            key={item.value}
            className={`app-formatmenu__item ${isActive ? "is-active" : ""}`}
            onClick={() => {
              dispatch(setPriceFormat(item.value));
              setFormatMenuOpen(false);
            }}
          >
            <span className="app-formatmenu__text">
              <b>{item.label}</b>
              <em>{formatCurrencyNoTooltip(FORMAT_SAMPLE_AMOUNT, item.value)}</em>
            </span>
            {isActive && <CheckOutlined className="app-formatmenu__check" />}
          </button>
        );
      })}
    </div>
  );
  const handleLogout = async () => {
    if (user?.is_tc) {
      try {
        const fcmToken = await requestForToken();
        if (fcmToken) {
          await dispatch(unregisterDeviceToken({ token: fcmToken }));
        }
      } catch (error) {
        console.error("Failed to unregister device token during logout:", error);
      }
      await dispatch(logoutUser());
    }

    clearFcmRegistration();
    dispatch(logout());
    navigate("/sign-in");
  };
  const title = propTitle || titleMap[location.pathname] || "App";
  const roleLabel = ROLE_LABELS[getUserType(user)] || "Collections";

  const fullName =
    [user?.first_name, user?.last_name].filter(Boolean).join(" ") || "User";

  const userMenu = (
    <div className="app-usermenu">
      <div className="app-usermenu__id">
        <Avatar size={40} icon={<UserOutlined />} />
        <div className="app-usermenu__id-text">
          <b title={fullName}>{fullName}</b>
          <span title={user?.email || roleLabel}>
            {user?.email || roleLabel}
          </span>
        </div>
      </div>
      <div className="app-usermenu__items">
        <button
          type="button"
          className="app-usermenu__item"
          onClick={() => {
            setUserMenuOpen(false);
            navigate("/profile");
          }}
        >
          <UserOutlined />
          Profile
        </button>
        <button
          type="button"
          className="app-usermenu__item is-danger"
          onClick={() => {
            setUserMenuOpen(false);
            handleLogout();
          }}
        >
          <LogoutOutlined />
          Logout
        </button>
      </div>
    </div>
  );

  const availableRoles = [];
  const checkRole = (roleKey) => user?.originalRoles ? user.originalRoles[roleKey] : user?.[roleKey];

  if (checkRole('is_supervisor')) availableRoles.push({ key: "supervisor", label: "Supervisor", icon: <DashboardOutlined /> });
  if (checkRole('is_tl')) availableRoles.push({ key: "team_lead", label: "Team Lead", icon: <TeamOutlined /> });
  if (checkRole('is_tc')) availableRoles.push({ key: "telecaller", label: "Telecaller", icon: <CustomerServiceOutlined /> });
  if (checkRole('is_fa')) availableRoles.push({ key: "field_agent", label: "Field Agent", icon: <UserOutlined /> });
  if (checkRole('is_agency')) availableRoles.push({ key: "agency", label: "Agency", icon: <BankOutlined /> });

  const isAgencyRole = getUserType(user) === "agency";

  /* The agent meter and the role switcher both sit in the header's right
     cluster, so with either present the three-way amount tabs run out of room
     sooner and fold into the dropdown at a wider viewport. */
  const isHeaderCrowded = isAgencyRole || availableRoles.length > 1;
  const isCompactFormat = viewportWidth < (isHeaderCrowded ? 1200 : 992);

  /* Before the first hire there is nothing on the users page to arrive at, so
     that one case carries the intent to open the form in history state - the
     page consumes it and clears it. Every other state just goes there and
     lets the page's own button do the asking. */
  const handleAddFirstAgent = () => {
    navigate("/agency/user", { state: { openAddUser: Date.now() } });
  };

  const handleOpenUserList = () => {
    navigate("/agency/user");
  };

  const handleRoleSwitch = async (roleKey) => {
    try {
      message.loading({ content: 'Switching role...', key: 'roleSwitch' });
      await dispatch(updateCurrentRole(roleKey)).unwrap();

      if (roleKey === 'telecaller') {
        axios.post('auth/attendance/action/', {}, { headers: { Authorization: `Bearer ${token}` } })
          .then(res => console.log('Attendance Manual Hit:', res.data))
          .catch(err => console.error('Attendance Manual Hit Error:', err));
      }

      dispatch(setSelectedRole(roleKey));
      message.success({ content: 'Role switched successfully!', key: 'roleSwitch', duration: 2 });
      navigate("/dashboard");
    } catch (error) {
      message.error({ content: 'Failed to switch role.', key: 'roleSwitch', duration: 2 });
    }
  };

  useEffect(() => {
    const handleResize = () => setViewportWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const breadcrumbNameMap = {
    // "/dashboard": "Dashboard",
    "/bank-dashboard": "Bank Dashboard",
    "/bank-dashboard/bank-details": "Dashboard",
    // "/agency": "Agency Details",
    // "/agency/user": "User",
    // "/agency/product": "Product",
    // "/agency/area-codes": "Area Codes",
    "/allocation/user-wise": "User Wise",
    "/allocation/cases": "Cases",
    "/portfolio": "Portfolio",
    "/company": "Company",
    // "/permission": "Rules",
    "/rules": "Rules",
    "/allocate": "Allocation",
    "/allocate/cases": "Cases",
    "/geo-tagging": "GEO Tagging",
    "/upload": "Upload",
    "/target-achievement": "Target & Achievement",
    "/analysis/overview": "Overview",
    "/analysis/coverage": "Coverage",
    "/analysis/productivity": "Productivity",
    "/analysis/performance": "Performance",
    "/collecteaze-ai": "Collecteaze Chat AI",
    // "/communication": "Connect",
    // "/communication/sms": "SMS",
    // "/communication/sms/create-template": "Create Template",
    // "/communication/sms/template": "Template",
    // "/communication/whatsapp": "Whatsapp",
    // "/communication/whatsapp/create-template": "Create Template",
    // "/communication/whatsapp/template": "Template",
    "/communication/email": "Email",
    "/communication/email/create-template": "Create Template",
    "/communication/email/template": "Template",
    "/script": "Call Script",
    "/campaign": "Campaign",
    "/whatsapp-campaign": "Whatsapp Campaign",
    "/sms-campaign": "SMS Campaign",
    "/attendance": "Attendance",
  };

  const pathSnippets = location.pathname.split("/").filter((i) => i);

  const breadcrumbItems = pathSnippets.map((snippet, idx) => {
    const url = `/${pathSnippets.slice(0, idx + 1).join("/")}`;
    const name =
      breadcrumbNameMap[url] ||
      snippet.charAt(0).toUpperCase() + snippet.slice(1);

    const isClickable = breadcrumbNameMap.hasOwnProperty(url);

    const decodedName = decodeURIComponent(name);

    const content =
      decodedName.length > 26 ? (
        <Tooltip color="black" title={decodedName}>
          <span>{decodedName.slice(0, 26) + "..."}</span>
        </Tooltip>
      ) : (
        <span>{decodedName}</span>
      );

    return {
      title: isClickable ? <Link to={url}>{content}</Link> : content,
    };
  });

  useEffect(() => {
    if (!collapsed) {
      const handleClickOutside = (event) => {
        const sider = document.querySelector(".slider_main");
        if (sider && !sider.contains(event.target)) {
          setCollapsed(true);
        }
      };
      document.addEventListener("mousedown", handleClickOutside);
      return () => {
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }
  }, [collapsed]);

  const findMenuItem = (key, items = menuItems) => {
    for (const item of items) {
      if (!item) continue;
      if (item.key === key) return item;
      if (item.children) {
        const found = findMenuItem(key, item.children);
        if (found) return found;
      }
    }
    return null;
  };

  const isLeafMenuItem = (key) => {
    const item = findMenuItem(key);
    return item ? !item.children : false;
  };

  /* Leaf items carry their route only inside the label's <Link>, so a click
     that lands on the row padding - or on the icon while the rail is
     collapsed and the label is hidden - never navigated. Handle the whole
     row here. Guarded on the current path so clicking the link itself does
     not push a duplicate history entry. */
  const navigateToMenuKey = (key) => {
    if (typeof key !== "string" || !key.startsWith("/")) return;
    if (pathname === key) return;
    navigate(key);
  };

  return (
    <ConfigProvider>
      <Card className="main_card" variant="borderless">
        <Layout
          style={{ minHeight: "100vh" }}
          className={`wrapper_layoutMain ${!isMobile && !collapsed ? "is-nav-expanded" : ""
            }`}
        >
          {/* Expanding the rail overlays the page like a drawer rather than
              squeezing the content, so this scrim sits behind it. */}
          {!isMobile && !collapsed && (
            <div
              className="sidebar-scrim"
              onClick={() => setCollapsed(true)}
              aria-hidden="true"
            />
          )}

          {!isMobile ? (
            <Sider
              collapsible
              collapsed={collapsed}
              onCollapse={setCollapsed}
              trigger={null}
              width={250}
              collapsedWidth={80}
              className={`slider_main ${collapsed ? "is-collapsed" : "is-expanded"}`}
            >
              <div className="sidebar-brand">
                <img
                  src={collapsed ? logo : fullLogo}
                  alt="Collecteaze"
                  className="sidebar-logo-img"
                />
              </div>

              <button
                type="button"
                className="sidebar-toggle"
                onClick={() => setCollapsed(!collapsed)}
                aria-label={collapsed ? "Expand sidebar" : "Collapse sidebar"}
                aria-expanded={!collapsed}
              >
                <RightOutlined />
              </button>

              <nav className="sidebar-nav">
                <ConfigProvider
                  theme={{
                    token: {
                      padding: 20,
                    },
                    components: {
                      Menu: {
                        itemHeight: 42,
                        itemBorderRadius: 10,
                        itemColor: "#4a4e60",
                        itemHoverColor: "#212330",
                        itemSelectedColor: "#ffffff",
                        itemSelectedBg: "#ff6843",
                        itemHoverBg: "#f6f9fc",
                        iconSize: 18,
                        itemMarginBlock: 3,
                        itemMarginInline: 0,
                      },
                    },
                  }}
                >
                  <Menu
                    mode="inline"
                    theme="light"
                    selectedKeys={[selectedKey]}
                    openKeys={openKeys}
                    onOpenChange={handleOpenChange}
                    defaultOpenKeys={openKey}
                    onClick={({ key }) => {
                      const item = findMenuItem(key);
                      if (item && item.children) {
                        handleSubMenuClick(key);
                      } else {
                        navigateToMenuKey(key);
                      }
                    }}
                    className="menu_list"
                    items={menuItems}
                    tooltipProps={{ open: false }}
                  />
                </ConfigProvider>
              </nav>
            </Sider>
          ) : (
            <Drawer
              title="Navigation"
              placement="left"
              onClose={() => setDrawerOpen(false)}
              open={drawerOpen}
              width={200}
              className="drawer_section"
            >
              <Menu
                mode="inline"
                theme="light"
                selectedKeys={[selectedKey]}
                openKeys={openKeys}
                onOpenChange={handleOpenChange}
                defaultOpenKeys={openKey}
                onClick={({ key }) => {
                  if (!isLeafMenuItem(key)) {
                    handleSubMenuClick(key);
                  } else {
                    navigateToMenuKey(key);
                    setDrawerOpen(false); // Close Drawer after navigation
                  }
                }}
                className="menu_list drawer_sidebar"
                items={menuItems}
                tooltipProps={collapsed ? { open: false } : undefined}
              />
            </Drawer>
          )}

          <Layout className="wrapper_layout" style={{ width: "100%" }}>
            <Header className="app-header">
              <div className="app-header__left">
                {isMobile && (
                  <button
                    type="button"
                    className="app-header__icon-btn"
                    onClick={() => setDrawerOpen(true)}
                    aria-label="Open navigation"
                  >
                    <MenuOutlined />
                  </button>
                )}
                <Breadcrumb
                  items={breadcrumbItems}
                  separator={<SeparatorIcon />}
                  className="customBreadcrumb"
                />
              </div>

              <div className="app-header__right">
                {availableRoles.length > 1 && (
                  <div className="app-header__role">
                    <UserSwitchOutlined className="app-header__role-icon" />
                    <Select
                      value={user?.selectedRole}
                      onChange={(value) => handleRoleSwitch(value)}
                      bordered={false}
                      dropdownStyle={{
                        borderRadius: '12px',
                        padding: '8px',
                        boxShadow: '0 10px 25px rgba(0,0,0,0.1)'
                      }}
                      style={{ minWidth: isCompactFormat ? 110 : 150 }}
                      className="premium-role-select"
                      suffixIcon={<DownOutlined style={{ color: '#f2654a' }} />}
                      options={availableRoles.map(role => ({
                        value: role.key,
                        label: (
                          <Space>
                            <span style={{ color: user?.selectedRole === role.key ? '#f2654a' : '#888' }}>
                              {role.icon}
                            </span>
                            <span style={{
                              fontWeight: user?.selectedRole === role.key ? 600 : 500,
                              color: user?.selectedRole === role.key ? '#f2654a' : '#333'
                            }}>
                              {role.label}
                            </span>
                          </Space>
                        )
                      }))}
                    />
                  </div>
                )}

                {/* {user?.selectedRole === 'telecaller' && (
                  <Badge count={unreadCount} offset={[-10, 5]}>
                    <Button 
                      type="text" 
                      icon={<BellOutlined style={{ fontSize: '20px', color: '#333' }} />}
                      onClick={() => setNotificationDrawerVisible(true)}
                      style={{ marginRight: 8, marginTop: 4 }}
                    />
                  </Badge>
                )} */}
                {user?.is_tc && (
                  <div className="app-header__breaks">
                    <span className="app-header__breaks-label">Break</span>
                    <Tooltip
                      title={activeBreak === "tea" ? "End tea break" : "Tea break"}
                    >
                      <button
                        type="button"
                        className={`agentBreakBtn ${activeBreak === "tea" ? "active" : ""}`}
                        onClick={() => handleBreakToggle("tea")}
                      >
                        <svg
                          width="14"
                          height="14"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        >
                          <path d="M10 2v2" />
                          <path d="M14 2v2" />
                          <path d="M16 8a1 1 0 0 1 1 1v8a4 4 0 0 1-4 4H7a4 4 0 0 1-4-4V9a1 1 0 0 1 1-1h14a4 4 0 1 1 0 8h-1" />
                          <path d="M6 2v2" />
                        </svg>
                      </button>
                    </Tooltip>
                    <Tooltip
                      title={
                        activeBreak === "lunch" ? "End lunch break" : "Lunch break"
                      }
                    >
                      <button
                        type="button"
                        className={`agentBreakBtn ${activeBreak === "lunch" ? "active" : ""}`}
                        onClick={() => handleBreakToggle("lunch")}
                      >
                        <svg
                          width="14"
                          height="14"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        >
                          <path d="M3 2v7c0 1.1.9 2 2 2h4a2 2 0 0 0 2-2V2" />
                          <path d="M7 2v20" />
                          <path d="M21 15V2a5 5 0 0 0-5 5v6c0 1.1.9 2 2 2h3Zm0 0v7" />
                        </svg>
                      </button>
                    </Tooltip>
                  </div>
                )}

                {showFilter && (
                  <div className="app-header__format">
                    {isCompactFormat ? (
                      <Dropdown
                        open={formatMenuOpen}
                        onOpenChange={setFormatMenuOpen}
                        trigger={["click"]}
                        placement="bottomRight"
                        dropdownRender={() => formatMenu}
                      >
                        <button
                          type="button"
                          className={`app-header__format-btn ${formatMenuOpen ? "is-open" : ""}`}
                          aria-label={`Amount format: ${activeFormat.label}`}
                          aria-haspopup="listbox"
                          aria-expanded={formatMenuOpen}
                        >
                          <CashIcon className="app-header__format-icon" />
                          <span className="app-header__format-value">
                            <span className="is-full">{activeFormat.label}</span>
                            <span className="is-short">{activeFormat.short}</span>
                          </span>
                          <DownOutlined className="app-header__caret" />
                        </button>
                      </Dropdown>
                    ) : (
                      <Tabs
                        options={formatPriceKeys}
                        active={format}
                        onChange={(val) => dispatch(setPriceFormat(val))}
                        showSelector={false}
                      />
                    )}
                  </div>
                )}

                <span className="app-header__divider" aria-hidden="true" />

                <Dropdown
                  open={userMenuOpen}
                  onOpenChange={setUserMenuOpen}
                  trigger={["click"]}
                  placement="bottomRight"
                  dropdownRender={() => userMenu}
                >
                  <button
                    type="button"
                    className={`app-header__user ${userMenuOpen ? "is-open" : ""}`}
                  >
                    <Avatar
                      size={34}
                      icon={<UserOutlined />}
                      className="app-header__avatar"
                    />
                    <span className="app-header__user-meta">
                      <b title={user?.first_name}>{user?.first_name || "User"}</b>
                      <em>{roleLabel}</em>
                    </span>
                    <DownOutlined className="app-header__caret" />
                  </button>
                </Dropdown>
              </div>
            </Header>

            <Content className="content_main">
              <div className="contentWrapper">{children}</div>
              <Toaster position="top-center" reverseOrder={false} />
            </Content>
          </Layout>
        </Layout>
      </Card>
      <NotificationDrawer
        visible={notificationDrawerVisible}
        onClose={() => setNotificationDrawerVisible(false)}
      />
    </ConfigProvider>
  );
};

export default PageLayout;

